import React from 'react';

import ListItem from 'components/ListItem';
import { numberToOrdinal } from 'utils/formatter/number-to-ordinal';

interface OwnProps {
    orderIntoTank: number;
}

export type Props = OwnProps;

export default class OrderIntoTankListItem extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { orderIntoTank } = this.props;

        return (
            <ListItem
                value={numberToOrdinal(orderIntoTank + 1)}
                description="Order into tank"
            />
        );
    }
}
